export default __webpack_public_path__ + "static/media/icon_medical_help.c21a0dc3.svg";